module.exports = __webpack_public_path__ + "static/img/company-default-bg.e3742dc5.png";